import { Store } from 'src/store/index';

const getLayoutSchemaSetName = (store: Store) => store.editor.layoutSchemaSetName;

export default getLayoutSchemaSetName;
